module.exports = __webpack_public_path__ + "img/logo-istry-dashboard-mini.6e2e0d2e.png";